import { render, staticRenderFns } from "./oss-upload-file.vue?vue&type=template&id=596cbd16&"
import script from "./oss-upload-file.vue?vue&type=script&lang=js&"
export * from "./oss-upload-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports